"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = {
  "muccia": {
    "d8680c47": [{
      "hkey": "fe544edd",
      "slug": "muccia",
      "name": "Muccia",
      "primary": true,
      "skipSearch": false
    }],
    "acquamoscia": [{
      "hkey": "fe544edd",
      "slug": "muccia",
      "name": "Muccia",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "9c1105ac": [{
      "hkey": "750c800a",
      "slug": "muccia",
      "name": "Muccia",
      "primary": true,
      "skipSearch": false
    }],
    "coda-di-muccia": [{
      "hkey": "750c800a",
      "slug": "muccia",
      "name": "Muccia",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": null
    }],
    "ebaa1239": [{
      "hkey": "fe544edd",
      "slug": "muccia",
      "name": "Muccia",
      "primary": true,
      "skipSearch": false
    }],
    "col-di-giove": [{
      "hkey": "fe544edd",
      "slug": "muccia",
      "name": "Muccia",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "b55e8009": [{
      "hkey": "fe544edd",
      "slug": "muccia",
      "name": "Muccia",
      "primary": true,
      "skipSearch": false
    }],
    "colle-della-rena": [{
      "hkey": "fe544edd",
      "slug": "muccia",
      "name": "Muccia",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "87599d9b": [{
      "hkey": "fe544edd",
      "slug": "muccia",
      "name": "Muccia",
      "primary": true,
      "skipSearch": false
    }],
    "giove": [{
      "hkey": "fe544edd",
      "slug": "muccia",
      "name": "Muccia",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "5472a3c5": [{
      "hkey": "fe544edd",
      "slug": "muccia",
      "name": "Muccia",
      "primary": true,
      "skipSearch": false
    }],
    "la-torre": [{
      "hkey": "fe544edd",
      "slug": "muccia",
      "name": "Muccia",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "8b4b1453": [{
      "hkey": "fe544edd",
      "slug": "muccia",
      "name": "Muccia",
      "primary": true,
      "skipSearch": false
    }],
    "marzocco": [{
      "hkey": "fe544edd",
      "slug": "muccia",
      "name": "Muccia",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "dbbe8c69": [{
      "hkey": "fe544edd",
      "slug": "muccia",
      "name": "Muccia",
      "primary": true,
      "skipSearch": false
    }],
    "palatina": [{
      "hkey": "fe544edd",
      "slug": "muccia",
      "name": "Muccia",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "40bb052e": [{
      "hkey": "fe544edd",
      "slug": "muccia",
      "name": "Muccia",
      "primary": true,
      "skipSearch": false
    }],
    "palazzi": [{
      "hkey": "fe544edd",
      "slug": "muccia",
      "name": "Muccia",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "9c70212c": [{
      "hkey": "fe544edd",
      "slug": "muccia",
      "name": "Muccia",
      "primary": true,
      "skipSearch": false
    }],
    "pian-di-giove": [{
      "hkey": "fe544edd",
      "slug": "muccia",
      "name": "Muccia",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "38105c87": [{
      "hkey": "fe544edd",
      "slug": "muccia",
      "name": "Muccia",
      "primary": true,
      "skipSearch": false
    }],
    "rocchetta": [{
      "hkey": "fe544edd",
      "slug": "muccia",
      "name": "Muccia",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "700a17e0": [{
      "hkey": "fe544edd",
      "slug": "muccia",
      "name": "Muccia",
      "primary": true,
      "skipSearch": false
    }],
    "starnacchio": [{
      "hkey": "fe544edd",
      "slug": "muccia",
      "name": "Muccia",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }]
  }
};
exports["default"] = _default;